const INIT_STATE = {
  docType: null,
  isLoading: false,
  isModalActive: false,
  message: '',
  recipient: '',
  subject: '',
  transactionId: null,
};

export function EmailTransactionModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case 'EMAIL_TRANSACTION_MODAL_RESET':
      return { ...INIT_STATE };
    case 'EMAIL_TRANSACTION_MODAL_SHOW':
      return { ...state, isModalActive: true };
    case 'EMAIL_TRANSACTION_MODAL_HIDE':
      return { ...state, isModalActive: false };
    case 'EMAIL_TRANSACTION_MODAL_TOGGLE':
      return { ...state, isModalActive: !state.isModalActive };
    case 'EMAIL_TRANSACTION_MODAL_SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'EMAIL_TRANSCTION_MODAL_SET_DATA':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
